export default __webpack_public_path__ + "1956a224b262e72dd92bbaca16cf55df.ply";